import { Record, List } from 'immutable';

const defaultValues = {
  id: null,
  recipeId: null,
  description: '',
  ordinal: 0,
};

export default class RecipeStep extends Record(defaultValues, RecipeStep) {
  constructor(values) {
    super({
      ...values,
    });
  }

  static getRecipeStepById(recipeSteps, id) {
    return recipeSteps.find((item) => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static getRecipeStepIndexById(recipeSteps, id) {
    return recipeSteps.findIndex(item => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static deleteRecipeStepByIndex(recipeSteps, index) {
    return recipeSteps.delete(index);
  }

  static insertRecipeStepByIndex(recipeSteps, index, recipeStep) {
    return recipeSteps.insert(index, recipeStep);
  }

  static sortRecipeStepByOrdinal(recipeSteps) {
    return recipeSteps.sort((itemOne, itemTwo) => {
      if (itemOne.get('ordinal') < itemTwo.get('ordinal')) return -1;
      if (itemOne.get('ordinal') > itemTwo.get('ordinal')) return 1;
      return 0;
    });
  }

  static updateRecipeStepOrdinalsFromIndex(recipeSteps) {
    return recipeSteps.map((item, index) => {
      return item.set('ordinal', index);
    });
  }

  static getNextOrdinal(recipeSteps) {
    const items = this.sortRecipeStepByOrdinal(recipeSteps);
    const item = items.last();
    if (item) {
      return item.get('ordinal') + 1;
    }
    return 0;
  }

  static formatRecipeStepsForOrdinalUpdate(recipeSteps) {
    const recipeStepsData = {
      ids: [],
    };
    recipeSteps.forEach((item) => {
      recipeStepsData.ids.push(item.get('id'));
    });
    return recipeStepsData;
  }
}

export const RecipeSteps = (data) => {
  let recipeSteps = new List();
  if (data) {
    data.forEach((value) => {
      recipeSteps = recipeSteps.push(new RecipeStep(value));
    });
  }
  return recipeSteps;
};
